import { useCombatantName } from './CombatantNamesContext';
import React from 'react';
import CombatDecisionPrompt from './CombatDecisionPrompt';
import { getSaveDamageDefinition } from '../../../shared/rules/effects/saveDamageDefinitions.mjs';

const ABILITY_LABELS = {
  strength: 'STR', dexterity: 'DEX', constitution: 'CON',
  intelligence: 'INT', wisdom: 'WIS', charisma: 'CHA',
};

export default function CombatSavePrompt({ opportunity, onRoll, onPass, resolving = false, error = '', children }) {
 const combatantName = useCombatantName();
  if (!opportunity) return null;
  const ability = opportunity.targetSave?.ability || opportunity.rules?.save?.ability;
  const dc = opportunity.targetSave?.dc ?? opportunity.rules?.save?.dc;
  const name = opportunity.sourceEffect?.displayName || opportunity.spell?.name ||
    getSaveDamageDefinition(opportunity.sourceDefinitionId)?.name || 'Saving Throw';

  if (process.env.NODE_ENV === 'development') {
    console.debug('[save-damage] render prompt', {
      resolutionId: opportunity.resolutionId,
      targetSaveStatus: opportunity.targetSave?.status,
      ability,
      dc,
      name,
    });
  }

  return (
    <CombatDecisionPrompt show title={name} primaryLabel="Roll Save" secondaryLabel="Pass"
      onPrimary={onRoll} onSecondary={onPass} resolving={resolving} error={error}>
      {opportunity.targetSave?.targetName && <p>Saving for <strong>{combatantName(opportunity.targetSave.targetCombatantId || opportunity.targetCombatantId, opportunity.targetSave.targetName)}</strong></p>}
      <p><strong>{ABILITY_LABELS[ability] || String(ability || 'Save').toUpperCase()} Saving Throw</strong><br />DC {dc}</p>
      {opportunity.targetSave?.rollMode && <p>{opportunity.targetSave.rollMode === 'disadvantage' ? 'Disadvantage: roll two d20s and use the lower result.' : 'Advantage: roll two d20s and use the higher result.'}</p>}
      {children}
      <small className="text-muted">Pass to fail the save without rolling.</small>
    </CombatDecisionPrompt>
  );
}

